module.exports = __webpack_public_path__ + "img/placeholder_lote_car_ttttt.7cf36625.png";